import React from "react";
import { useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

/**
 * A single compact KPI/metric tile: small icon, label, primary value,
 * optional caption. Touch-friendly (44px min-height, real onClick - no
 * hover-only behaviour), keyboard-operable when clickable.
 */
export default function MetricCard({ icon, label, value, caption, route, attention = false }) {
  const history = useHistory();
  const clickable = Boolean(route);

  const handleActivate = () => {
    if (clickable) history.push(route);
  };

  return (
    <div
      className={`metric-card ${clickable ? "metric-card--clickable" : ""} ${attention ? "metric-card--attention" : ""}`}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={clickable ? handleActivate : undefined}
      onKeyDown={
        clickable
          ? e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleActivate();
              }
            }
          : undefined
      }
    >
      {icon && (
        <span className="metric-card__icon" aria-hidden="true">
          <SVG src={toAbsoluteUrl(icon)} />
        </span>
      )}
      <div className="metric-card__body">
        <div className="metric-card__label">{label}</div>
        <div className="metric-card__value">{value === undefined || value === null ? "\u2013" : value}</div>
        {caption && <div className="metric-card__caption">{caption}</div>}
      </div>
    </div>
  );
}
